import { useTheme } from '@/contexts/ThemeContext';
import { NPSDReportsGrid } from '@/components/npsd/NPSDReportsGrid';
import { NPSDCallCardsGrid } from '@/components/npsd/NPSDCallCardsGrid';

interface NPSDVehicleHistoryProps {
  vehicleId: number | string | null;
  reports: any[];
  onViewReport?: (reportId: any) => void;
}

export function NPSDVehicleHistory({
  vehicleId = null,
  reports = [],
  onViewReport,
}: NPSDVehicleHistoryProps) {
  const { theme } = useTheme();

  return (
    <div className={`npsd-vehicle-history ${theme}`}>
      {/* Reports Section */}
      <NPSDReportsGrid
        reports={reports}
        title="Reports Involving Vehicle"
        entityType="vehicle"
        onViewReport={onViewReport}
      />

      {/* Call Cards Section */}
      <NPSDCallCardsGrid
        entityId={vehicleId}
        entityType="vehicle"
        entityIdField="vehicleId"
        title="Call Cards Involving Vehicle"
        showRefresh={true}
      />
    </div>
  );
}

(window as any).NPSDVehicleHistoryReact = NPSDVehicleHistory;
